import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Img from "../../../images/locationgcc/qa/banner-img.webp";
import BgImg from "../../../images/locationgcc/qa/banner_bg.webp";

function Banner(props) {
  return (
    <div
      className="locationgcc_banner no-bread-loc-banner"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Qatar">
                <h1>Mobile App Development Company in Qatar</h1>
              </div>
              <p className="main_para">
                Maximize your business potential by digitizing it with a
                stunning mobile app and dominate the rapidly growing market of
                Qatar. Our mobile app development company holds a solid record
                of facilitating businesses from different industry traits based
                on our potential in the latest technologies with utter
                innovation. So, you can capitalize on our services resulting in
                2X ROI and assured scalability.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                {" "}
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <LazyLoadImage
              src={Img}
              effect="blur"
              alt="mobile app development company in qatar"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
